<template>
  <div class="floor">
    <div style="width: 100%; height: 50px"></div>
    <p>全国高校招生咨询平台（河南）</p>
    <p>
	   <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color:#FFFFFF">豫ICP备2022026069</a>
      地址：河南省郑州市管城区东大街185号 服务中心电话：0371-66351540
      邮编：450099
    </p>
    <p>监督投诉：heneea@126.com 版权所有：河南省高招益教教育科技有限公司</p>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.floor {
  width: 100%;
  height: 200px;
  background-color: #da2d1f;
  p {
    color: #f5fcf4;
    text-align: center;
    margin: 15px 0;
  }
}
</style>
